import { renderDrawerFooter } from '../../Drawer/DrawerFooter';

/**
 * Renders the final JSX of NavDrawerFooter.
 */
export const renderNavDrawerFooter = renderDrawerFooter;
